import $ from "jquery";
import "slick-carousel";

const sliderRelatedProductSlick = () => {
  $(".ProductsSlider ul.products").slick({
    slidesToShow: 4,
    slidesToScroll: 4,
    arrows: true,
    infinite: false,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: true,
          variableWidth: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          variableWidth: false,
          arrows: true,
        },
      },
      {
        breakpoint: 601,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          variableWidth: false,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: false,
        },
      },
    ],
  });
};

try {
  sliderRelatedProductSlick();
} catch (error) {
  console.log(error);
}
